// Match score: simple inverse-distance over the vibe axes, 0-100.
const AXES = ['physical', 'social', 'outdoor', 'newPeople', 'creative', 'boozy', 'eating', 'expensive'];

export function matchScore(user, activity) {
  const dist = AXES.reduce((s, k) => s + Math.abs((user[k] ?? 50) - (activity.vibe[k] ?? 50)), 0);
  return Math.max(0, Math.round(100 - dist / AXES.length));
}
